import {request} from "./request";

export const findUserPassword = params => {
  return request.post({
    path: "/engine/find/user/password",
    params,
  });
};
